export default () => {
  let buttons = document.querySelectorAll('.btn--with-icon');
  Array.prototype.forEach.call(buttons, function (item, index) {
    let icon = item.querySelectorAll('img')[0];
    item.addEventListener('mouseenter', function () {
      if (!item.classList.contains('active')) {
        if (icon !== null) {
          icon.src = icon.dataset.hover;
        }
      }
    });

    item.addEventListener('mouseover', function () {
      if (!item.classList.contains('active')) {
        if (icon !== null) {
          icon.src = icon.dataset.hover;
        }
      }
    });

    item.addEventListener('mouseout', function () {
      if (!item.classList.contains('active')) {
        if (icon !== null) {
          icon.src = icon.dataset.normal;
        }
      }
    });

    if (
      item.classList.contains('active') &&
      icon !== null &&
      icon.dataset.hover !== undefined &&
      item.dataset.hover !== null
    ) {
      icon.src = icon.dataset.hover;
    }
  });
};
